<template>
  <card-view :toLink="currentLink">
    <div class="mb-3">
      <h2 class="results-div">Scorecard for:</h2>
      <div class="results-div">{{ placeName }}</div>
    </div>
    <ProgressSpinner
      v-if="!displayResults && !showToast"
      style="width: 50px; height: 50px"
      strokeWidth="8"
      animationDuration="1s"
    />
    <div v-if="displayResults">
      <letter-grade
        v-for="item in results.data"
        :key="item.name"
        :item="item"
        :showDetails="hasSubmitted"
      ></letter-grade>
    </div>
    <Message :closable="false" v-if="showToast" severity="error">{{
      toastMessage
    }}</Message>
    <template v-slot:footer-button>
      <div v-if="hasSubmitted">
        <router-link
          :to="{ name: 'home' }"
          style="text-decoration: none; color: inherit"
          :showDetails="hasSubmitted"
        >
          <Button icon="pi pi-times" label="Start Over" class="p-button-text" />
        </router-link>
      </div>
      <div v-if="!hasSubmitted">
        <router-link
          :to="{ name: 'home' }"
          style="text-decoration: none; color: inherit"
        >
          <Button icon="pi pi-times" label="Back" class="p-button-text" />
          <router-link
            :to="{ name: 'signup' }"
            style="text-decoration: none; color: inherit"
          >
            <Button
              label="More Details"
              class="p-button-raised"
              style="margin-left: 0.5em"
            />
          </router-link>
        </router-link>
      </div>
    </template>
  </card-view>
</template>

<script>
import CardView from "./CardView.vue";
import { defineAsyncComponent } from "vue";
import { hasSubmitted, validAddress, results } from "../state";
import { ref } from "vue";
import axios from "axios";

export default {
  props: ["validAddress", "triggerToast"],
  components: {
    CardView,
    LetterGrade: defineAsyncComponent(() => import("./LetterGrade.vue")),
  },
  name: "scorecard",

  data() {
    const placeName = ref(null);
    const showToast = ref(false);
    const toastMessage = ref("");
    const displayResults = ref(false);

    if (!results.data) {
      placeName.value = validAddress.data.value.place_name;
      this.getData(placeName);
    }
    if (placeName.value !== validAddress.data.value.place_name) {
      placeName.value = validAddress.data.value.place_name;
      this.getData(placeName);
    }

    return {
      currentLink: "signup",
      hasSubmitted,
      placeName,
      results,
      showToast,
      toastMessage,
      displayResults,
    };
  },
  methods: {
    getData() {
      this.$gtag.event("address_search", { content_type: validAddress.data.value.place_name });
      axios
        .get(`/api/results/${validAddress.data.value.geometry.coordinates}`, {
          params: { submittedForm: hasSubmitted.value },
        })
        .then((response) => {
          this.displayResults = true;
          this.results.data = response.data;
        })
        .catch((err) => {
          this.showToast = true;
          this.toastMessage = err.response.data.message;
        });
    },
  },
};
</script>

<style>
.p-datatable-thead {
  display: none;
}
.results-div {
  display: inline-block;
  vertical-align: -webkit-baseline-middle;
  width: 200px;
}
</style>